import { LoadingDialog } from '@/components/controls';
import { useDeleteLocation, useLocation, useUpsertLocation } from '@/hooks';
import { useMemo } from 'react';
import { SceneEditorDialog } from './SceneEditorDialog';

export function SceneEditor({ code, isOpen, onClose, groupCodes }) {
  const defaultScene = useMemo(
    () => ({
      name: '',
      type: 'SCENE',
      boundary: null,
      groupCodes,
      attributes: {
        incidentCode: '',
        occurrenceNumber: '',
        requiredAttendance: 0,
      },
    }),
    [groupCodes],
  );
  const {
    query: { data: fetchedScene },
  } = useLocation(code);
  const scene = code === 'new' ? defaultScene : fetchedScene;
  const { mutate: upsertLocation } = useUpsertLocation();
  const { mutate: deleteLocation } = useDeleteLocation();

  function handleClose(values) {
    if (values) {
      upsertLocation(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteLocation(code);

    onClose();
  }

  return scene ? (
    <SceneEditorDialog
      scene={scene}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
      groupCodes={groupCodes}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
